"use client";

import { ui } from "@/lib/locales/ui";
import type { UiMessages } from "@/lib/locales/types";
import { useLang } from "./lang-context";

export { useLang };

/** The interface's words in the page's language (lib/locales/ui). */
export function useUi(): UiMessages {
  return ui(useLang());
}
